.root {
  --card-border-radius: 20px;
  --z-index-image: calc(var(--z-index-product-card, 1) - 1);
  --z-index-content: var(--z-index-product-card, 1);
  --z-index-line: calc(var(--z-index-product-card, 1) + 1);

  direction: rtl;
  background-color: grey;
  border-radius: var(--card-border-radius);
  position: relative;
  display: block;
}

.content {
  display: grid;
  padding-top: 68.75%;
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  align-content: space-between;
  height: 100%;
  position: relative;
  border-radius: var(--card-border-radius);
}

.labels-container {
  position: absolute;
  padding: 10px 10px 20px 10px;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: var(--z-index-content);
  display: grid;
  border-radius: var(--card-border-radius);
  background-image: linear-gradient(
    to bottom,
    transparent,
    transparent,
    transparent,
    transparent,
    rgba(88, 91, 118, 0.7),
    rgba(88, 91, 118, 0.9),
    rgba(88, 91, 118, 0.99)
  );
}

.title {
  font-size: 26px;
  font-weight: 700;
  line-height: 0.8;
  color: #fff;
  justify-self: flex-start;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
}

.date {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 4px;
}

.marketing-label {
  background-color: #03ea52;
  font-size: 16px;
  font-weight: 700;
  line-height: 19.2px;
  color: #000;
  min-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: absolute;
  padding: 9.5px 0;
  border-radius: 20px 20px 0 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
}

.price {
  font-size: 38px;
  font-weight: 700;
  color: #fff;
  line-height: 0.7;
}

.currency {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  line-height: 0.7;
}

.labels-wrap {
  display: flex;
  align-content: center;
  justify-content: space-between;
  overflow: hidden;
  gap: 4px;
}

.seats-label {
  background-color: var(--active-category-color, #03ea52);
  font-size: 13px;
  font-weight: 700;
  border-radius: 16px;
  padding: 4px 6px;
  margin-bottom: 10px;
  color: #fff;
  justify-self: flex-start;
  align-self: baseline;
  text-overflow: ellipsis;
  white-space: nowrap;

  &--sold-out {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
  }
}

.title-block {
  display: grid;
  gap: 2px;
  align-content: end;
}

.price-block {
  display: grid;
  align-content: end;
}

.price-label {
  display: flex;
  align-items: flex-end;
  justify-content: end;
  margin-inline-end: 6px;
  gap: 2px;
  height: 30px;
}

.arrow-end {
  transform: rotate(-45deg);
  display: block;
  margin: 6px 0;
  width: 16px;
  height: 16px;
  border-top: 2px solid var(--active-category-color, #03ea52);
  border-left: 2px solid var(--active-category-color, #03ea52);
  transition: all 0.2s ease-in-out;
}

.line-block {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  height: 20px;
  border-bottom-left-radius: var(--card-border-radius);
  border-bottom-right-radius: var(--card-border-radius);
}

.line {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: var(--active-category-color, #03ea52);
  z-index: var(--z-index-line);
  transition: background-color 0.2s ease-in-out;
}

.image {
  position: absolute;
  z-index: var(--z-index-image);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border-radius: var(--card-border-radius);
  object-fit: cover;
  width: 100%;
  height: 100%;

  &--sold-out {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
  }
}

@media (max-width: 768px) {
  .seats-label {
    padding: 4px 10px;
  }
}

.seats-label-shows {
  justify-self: end;
}
